if (typeof Hotkeys === 'undefined') Hotkeys = {};

"use strict";

Hotkeys.handle = function(event) {
    var code = CoreUI.keyCode(event);
    if ((code == 187 && event.shiftKey) || (code == 191 && event.shiftKey) || (code == 171 && event.shiftKey)) { // '?'
        return 'help';
    } else if ((code == 55 && event.shiftKey) || code == 191) { // '/'
        return 'search';
    } else if (code == 78 && event.altKey) { // alt-N
        return 'new';
    }
    return null;
};

Hotkeys.help = function() {
    ModalDialogView.showTemplate('hotkeys-help-template');
    $('#modal .btn-primary').focus();
};

Hotkeys.search = function() {
    $('#show-global-search').click();
};

Hotkeys.new = function() {
    // These options should match *list.js hasCreatePermission() or equivalent
    var templateData = {
            reservation: Core.client.hasPermission('create_reservations') && (!Core.client.me.get('primaryGroupId') || !Core.client.me.get('shareAllWithPrimaryGroup') || Core.client.hasGroupPermission(Core.client.me.get('primaryGroupId'), 'create_reservations')),
            order: Core.client.hasFeature('orders') && Core.client.hasPermission('create_orders') && (!Core.client.me.get('primaryGroupId') || !Core.client.me.get('shareAllWithPrimaryGroup') || Core.client.hasGroupPermission(Core.client.me.get('primaryGroupId'), 'create_orders')),
            job: Core.client.hasFeature('jobs') && Core.client.hasPermission('create_jobs') && (!Core.client.me.get('primaryGroupId') || !Core.client.me.get('shareAllWithPrimaryGroup') || Core.client.hasGroupPermission(Core.client.me.get('primaryGroupId'), 'create_jobs')),
            route: Core.client.hasFeature('routes') && Core.client.hasPermission('create_routes') && (!Core.client.me.get('primaryGroupId') || !Core.client.me.get('shareAllWithPrimaryGroup') || Core.client.hasGroupPermission(Core.client.me.get('primaryGroupId'), 'create_jobs')),
            report: Core.client.hasFeature('work_reports') && Core.client.hasPermission('report_work') && Core.client.groups.length > 0
                            && ( !Core.client.me.get('primaryGroupId')
                            || !Core.client.me.get('shareAllWithPrimaryGroup')
                            || ( (Core.client.hasGroupPermission(Core.client.me.get('primaryGroupId'), 'do_work')
                            || Core.client.hasGroupPermission(Core.client.me.get('primaryGroupId'), 'alter_work_reports'))
                            && !Core.client.primaryGroupHasConfiguration('no_adhoc_reports') ) ),
            absence: Core.client.hasFeature('absence') && Core.client.hasPermission('report_work') && Core.client.groups.length > 0
                            && ( !Core.client.me.get('primaryGroupId')
                            || !Core.client.me.get('shareAllWithPrimaryGroup')
                            || ( (Core.client.hasGroupPermission(Core.client.me.get('primaryGroupId'), 'do_work')
                            || Core.client.hasGroupPermission(Core.client.me.get('primaryGroupId'), 'alter_work_reports'))
                            && !Core.client.primaryGroupHasConfiguration('no_adhoc_reports') ) ),
            customer: Core.client.hasPermission('edit_all_data') || !Core.client.primaryGroup() || !Core.client.me.get('shareAllWithPrimaryGroup') || Core.client.hasGroupPermission(Core.client.primaryGroup(), 'create_customers'),
            article: !Core.client.primaryGroup() || !Core.client.me.get('shareAllWithPrimaryGroup') || Core.client.hasGroupPermission(Core.client.primaryGroup(), 'admin_articles'),
            asset: Core.client.hasFeature('assets') && Core.client.hasPermissionInAnyGroup('create_assets'),
        };
    ModalDialogView.showTemplate('hotkeys-new-template', templateData);
    $('#modal li:first-child a').focus();
    $('#modal a').click(function (event) {
        $('#modal').modal('hide');
        return true;
    });
};

$(document).on('keydown keyup',
               function(event) {
                   Hotkeys.shiftKey = event.shiftKey;
                   Hotkeys.ctrlKey = event.ctrlKey;
                   Hotkeys.metaKey = event.metaKey;
                   Hotkeys.altKey = event.altKey;
                   if ($('.logged-in').length == 0) return;
                   var el = document.activeElement;
                   if (!(event.altKey || event.ctrlKey || event.metaKey) && el && (el.tagName == 'INPUT' || el.tagName == 'SELECT' || el.tagName == 'TEXTAREA')) return true;

                   if (event.type === 'keydown') {
                       var func = Hotkeys.handle(event);
                       if (func) {
                           debug.log('hotkey ' + func);
                           Hotkeys[func]();
                           return false;
                       } else if (window.view && window.view.hotkey && window.view.hotkey(event)) {
                           return false;
                       } else
                           debug.log('no hotkey ' + (event.shiftKey ? 'shift ' : '') + (event.ctrlKey ? 'ctrl ' : '') + (event.metaKey ? 'meta ' : '') + (event.altKey ? 'alt ' : '') + CoreUI.keyCode(event));
                   } else {
                       if (window.view && window.view.hotkeyUp) {
                           window.view.hotkeyUp(event);
                           return false;
                       }
                   }
                   return true;
               });
